"use client";

import { useToast } from "@/components/ui/toastercustom";
import { ERROR_MESSAGES_LOGIN } from "@/constants/messages";
import { IAuthData } from "@/features/authentication/interfaces/IAuth";
import { login } from "@/features/authentication/services/auth.services";
import useProfileStore from "@/stores/profile";
import { onSetCookie } from "@/utils/handleCookie";
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { useState } from "react";
const useLogin = () => {
  // Router
  const router = useRouter();

  // Store
  const { setToken, setProfile, setRefreshToken } = useProfileStore();

  // State
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState<boolean>(false);

  // toast
  const { toast } = useToast();

  // USE MUTATION ---------------------------------------------------------
  const { mutate: mutateLogin } = useMutation({
    mutationKey: ["login"],
    mutationFn: async (data: Pick<IAuthData, "email" | "password">) => {
      const result = await login(data);
      if (result && result.status) {
        // After successful login, display toast
        toast({
          title: "Success",
          type: "success",
          text: "Login successful",
        });

        // Save data to local storage using Zustand
        // TODO: BE should return app data user
        setProfile(result.data);
        setToken(result.token);
        onSetCookie({
          token: result.token,
          refresh_token: result.refresh_token.token,
          created_from: result.data.created_from,
        });
        setRefreshToken(result.refresh_token);
        router.push("/my-agents");
      } else {
        // When status is false
        toast({
          title: "Error",
          type: "error",
          text: result?.message || ERROR_MESSAGES_LOGIN,
        });
      }
    },
    onSuccess: () => {
      setIsDisabled(false);
    },
    onError: () => {
      setIsDisabled(false);
      toast({
        title: "Error",
        type: "error",
        text: "Login failed",
      });
    },
  });
  // -----------------------------------------------------------------------

  // Add your onSubmit function here
  const onSubmit = (data: Pick<IAuthData, "email" | "password">) => {
    setIsDisabled(true);
    mutateLogin(data);
  };

  return {
    onSubmit,
    isDisabled,
    showPassword,
    setShowPassword,
  };
};

export default useLogin;
